import { render, staticRenderFns } from "./AllTweetsFollow.vue?vue&type=template&id=5ccd2348&scoped=true"
import script from "./AllTweetsFollow.vue?vue&type=script&lang=js"
export * from "./AllTweetsFollow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccd2348",
  null
  
)

export default component.exports